module.exports = __webpack_public_path__ + "static/media/YM74_2.4e343334.jpg";